import {
    GET_ACCOUNT_MANAGER_LIST_PROGRESS, GET_ACCOUNT_MANAGER_LIST_SUCCESS, GET_ACCOUNT_MANAGER_LIST_FAILURE,
    ADD_ACCOUNT_MANAGER_PROGRESS, ADD_ACCOUNT_MANAGER_SUCCESS, ADD_ACCOUNT_MANAGER_FAILURE,
    EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS, EDIT_DELETE_ACCOUNT_MANAGER_SUCCESS, EDIT_DELETE_ACCOUNT_MANAGER_FAILURE,
   
    RESET_MESSAGE,

} from '../types/actionTypes';

const initialState = {
    accountManager: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const account_manager_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ACCOUNT_MANAGER_LIST_SUCCESS:
            return { ...state, accountManager: action.accountManager, loading: false };
        case GET_ACCOUNT_MANAGER_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_ACCOUNT_MANAGER_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_ACCOUNT_MANAGER_PROGRESS:
            return { ...state, loading: true };
        case ADD_ACCOUNT_MANAGER_SUCCESS:
            return { ...state, accountManager: [...state.accountManager, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_ACCOUNT_MANAGER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_ACCOUNT_MANAGER_SUCCESS:
            return {
                ...state,
                accountManager: state.accountManager.map((accountManager) =>
                accountManager.id === action.payload.id ? action.payload : accountManager
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_ACCOUNT_MANAGER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default account_manager_reducer;